(() => {
  'use strict';
  const root = document.querySelector('[data-ac-menu]');
  const data = window.AussieMenuData;
  if (!root || !data) return;
  const $ = (selector) => root.querySelector(selector);
  const $$ = (selector) => [...root.querySelectorAll(selector)];
  const messages = {
    pt: {
      speedPromptClose: 'Fechar convite', speedShareTitle: 'Quer compartilhar sua velocidade?', speedShareBody: 'Seu resultado em um cartão da Aussie Coffee. Compartilhe ou salve para postar.', speedShareAction: 'Compartilhar resultado', speedSave: 'Salvar imagem do resultado', speedBanner: 'Aussie Coffee Fibre Optic', speedClub: 'Wi-Fi com gingado.', speedFuel: 'Movido a café ☕', speedNomads: 'Seu escritório de hoje? O Rio.', speedCopy: 'Copiar resultado', speedCopied: 'Resultado copiado!', speedCopyFallback: 'Copie o texto abaixo para compartilhar.', speedNotNow: 'Agora não', speedReviewTitle: 'Como foi nosso Wi-Fi?', speedReviewBody: 'Usou o Wi-Fi aqui no café? Que tal contar sua experiência no Google Maps?', speedReviewAction: 'Avaliar no Google Maps', 
      connectionTitle: 'Teste de velocidade do Wi-Fi', connectionIntro: 'Café especial. Trabalho remoto. Conexão carioca.', connectionStartHint: 'Toque para iniciar', speedQuietShare: 'Compartilhe seu resultado', connectionStart: 'Iniciar', connectionRetry: 'Testar de novo', connectionTesting: 'Testando…', connectionDownload: 'Download estimado', connectionResponse: 'Tempo de resposta', connectionNote: 'Média estimada de download em 5 segundos na conexão atual.', connectionWaiting: 'Toque em Iniciar para testar sua conexão.', connectionRunning: 'Medindo sua velocidade por 5 segundos…', connectionWarming: 'Aquecendo os motores…', connectionComplete: 'Pronto! Essa é a sua velocidade.', connectionOffline: 'Você está offline. Conecte-se e tente de novo.', connectionError: 'Ops! Não deu para concluir. Vamos de novo?',
      communitySearch: 'Busque na comunidade', communitySearchPrompt: 'Busque por pessoa ou serviço', communityNoResults: 'Nenhuma conexão encontrada. Tente outra palavra.', communityMatches: 'conexões encontradas',
      welcomeEyebrow: 'BEM-VINDO À AUSSIE', welcomeHeading: 'Bem-vindo.',
      welcomeIntro: 'Café especial e brunch o dia inteiro.', comingSoon: 'Em breve', communityTitle: "Aussie Coffee's Digital Community Board", communityGuide: 'Explore uma área. Toque em uma pessoa para conhecer seu trabalho.', communityHub: 'Amigos no Rio', communityConnections: 'conexões', communityConnection: 'conexão', communityEmpty: 'Novas conexões em breve.', backWelcome: '← Voltar ao início', visitInstagram: 'Visitar Instagram', visitWebsite: 'Visitar site', visitLinkedIn: 'Ver no LinkedIn', sendEmail: 'Enviar e-mail', communityIntro: "Como um mural de recados de café, este espaço apoia meus amigos e jovens empreendedores locais no Rio, conectando você a passeios, bem-estar, arte e serviços.",
      viewMenu: 'Bora comer?', viewMenuSub: 'Escolha seu próximo favorito', welcomeCaption: 'Feito com cuidado. Servido com calma.',
      photoCaption: 'Um pedacinho da Austrália.<br>Com alma brasileira.', welcomeNote: 'CAFÉ ESPECIAL · BRUNCH · BOAS CONVERSAS',
      visitSite: 'Conheça a Aussie ↗', searchLabel: 'Buscar no cardápio', searchPlaceholder: 'O que vai ser hoje?', digitalMenu: 'CARDÁPIO DIGITAL',
      featuredEyebrow: 'COM A CARA DA AUSSIE', featuredHeading: 'Best Sellers', featuredHint: 'Nossos mais pedidos. Combine seus favoritos do seu jeito.',
      emptyHeading: 'Não encontramos essa opção.', emptyText: 'Tente outro nome, ingrediente ou categoria.', clearSearch: 'Limpar busca',
      menuReviewPrompt: 'Como foi sua visita?', menuReviewLink: 'Deixe sua avaliação no Google', orderNote: 'Escolheu? Faça seu pedido com a nossa equipe.', serviceNote: 'Serviço de 10%. Consulte a equipe sobre alergênicos e disponibilidade.',
      categories: 'Categorias', swipeCategories: 'Deslize para os lados para trocar de categoria', from: 'A partir de', included: 'Incluso', optional: 'Opcional', choose: 'Opções disponíveis',
      detailNote: 'Para pedir ou personalizar, fale com a nossa equipe.', donationNote: 'Para contribuir, fale com a nossa equipe. Pagamento separado.',
      close: 'Fechar detalhes', closeCategories: 'Fechar categorias', allCategories: 'Todas as categorias', backTop: 'Voltar ao início do cardápio',
      viewDetails: 'Ver detalhes de', results: 'resultado(s) para', itemCount: 'opções', donation: 'Contribuição',
      intros: {48: 'Do primeiro espresso ao seu favorito gelado.',75: 'Sem pressa. Seu brunch a qualquer hora.',51: 'Frutas frescas, preparadas na hora.',98: 'Um brinde aos bons momentos.',50: 'Outros sabores para acompanhar seu dia.',93: 'Cremosos, frescos e cheios de sabor.',76: 'Do seu jeito, com algo a mais.',52: 'Sempre cabe um pedacinho.',88: 'Um pouco da Aussie para levar.',92: 'Conheça e apoie essa iniciativa.'}
    },
    en: {
      speedPromptClose: 'Close invitation', speedShareTitle: 'Want to share your speed?', speedShareBody: 'Your score on an Aussie Coffee card. Share it or save it to post.', speedShareAction: 'Share result', speedSave: 'Save result image', speedBanner: 'Aussie Coffee Fibre Optic', speedClub: 'Good coffee. Big connection.', speedFuel: 'Coffee-powered ☕', speedNomads: 'Today’s office? Rio.', speedCopy: 'Copy result', speedCopied: 'Result copied!', speedCopyFallback: 'Copy the text below to share.', speedNotNow: 'Not now', speedReviewTitle: 'How was our Wi-Fi?', speedReviewBody: 'Used the Wi-Fi here at the café? Would you share your experience on Google Maps?', speedReviewAction: 'Review on Google Maps', 
      connectionTitle: 'Wi-Fi Speed Test', connectionIntro: 'Specialty coffee. Remote work. Rio connection.', connectionStartHint: 'Click to start', speedQuietShare: 'Share your result', connectionStart: 'Start', connectionRetry: 'Test again', connectionTesting: 'Testing…', connectionDownload: 'Estimated download', connectionResponse: 'Response time', connectionNote: 'Estimated 5-second download average on your current connection.', connectionWaiting: 'Tap Start to test your connection.', connectionRunning: 'Measuring your speed for 5 seconds…', connectionWarming: 'Warming up the engines…', connectionComplete: 'All done! Here’s your speed.', connectionOffline: 'You’re offline. Connect and try again.', connectionError: 'Oops! That didn’t finish. Give it another go.',
      communitySearch: 'Search our community', communitySearchPrompt: 'Search for a person or service', communityNoResults: 'No connections found. Try another keyword.', communityMatches: 'connections found',
      welcomeEyebrow: 'WELCOME TO AUSSIE', welcomeHeading: 'Welcome.',
      welcomeIntro: 'Specialty coffee and all-day brunch.', comingSoon: 'Coming soon', communityTitle: "Aussie Coffee's Digital Community Board", communityGuide: 'Explore an area. Tap a person to discover their work.', communityHub: 'Friends in Rio', communityConnections: 'connections', communityConnection: 'connection', communityEmpty: 'New connections coming soon.', backWelcome: '← Back to welcome', visitInstagram: 'Visit Instagram', visitWebsite: 'Visit website', visitLinkedIn: 'View on LinkedIn', sendEmail: 'Send an email', communityIntro: "Like a café noticeboard, this space supports my friends and young local entrepreneurs in Rio, connecting you with trips, wellbeing, art and services.",
      viewMenu: 'Explore the menu', viewMenuSub: 'Find your next favourite', welcomeCaption: 'Made with care. Savoured slowly.',
      photoCaption: 'A little piece of Australia.<br>With a Brazilian soul.', welcomeNote: 'SPECIALTY COFFEE · BRUNCH · GOOD CONVERSATIONS',
      visitSite: 'Meet Aussie ↗', searchLabel: 'Search the menu', searchPlaceholder: 'What are you having today?', digitalMenu: 'DIGITAL MENU',
      featuredEyebrow: 'A TASTE OF AUSSIE', featuredHeading: 'Best Sellers', featuredHint: 'Our best sellers. Mix and match your favourites.',
      emptyHeading: 'We couldn’t find that one.', emptyText: 'Try another name, ingredient or category.', clearSearch: 'Clear search',
      menuReviewPrompt: 'How was your visit?', menuReviewLink: 'Leave us a review on Google', orderNote: 'Found your favourite? Order with our team.', serviceNote: '10% service charge. Ask our team about allergens and availability.',
      categories: 'Categories', swipeCategories: 'Swipe left or right to change category', from: 'From', included: 'Included', optional: 'Optional', choose: 'Available options',
      detailNote: 'To order or customise, please speak with our team.', donationNote: 'To contribute, please speak with our team. Separate payment.',
      close: 'Close item details', closeCategories: 'Close categories', allCategories: 'All categories', backTop: 'Back to the top of the menu',
      viewDetails: 'View details for', results: 'result(s) for', itemCount: 'options', donation: 'Contribution',
      intros: {48: 'From your first espresso to your iced favourite.',75: 'Take your time. Brunch, all day long.',51: 'Fresh fruit, prepared to order.',98: 'Here’s to the good moments.',50: 'Something different to brighten your day.',93: 'Fresh, creamy and full of flavour.',76: 'Make it yours with a little extra.',52: 'There’s always room for something sweet.',88: 'Take a little Aussie home.',92: 'Discover and support this initiative.'}
    }
  };
  const englishLabels = {
    'Acréscimos': 'Extras', 'Opção de Leite': 'Milk options', 'com Gingibre': 'Add ginger', 'Sabores de Cha': 'Tea flavours',
    'Adoçar?': 'Sweetener', 'Quente ou Frio?': 'Hot or iced?', 'com Matcha': 'Add matcha', 'Mel': 'Honey', 'Leite Integral ou Vegano': 'Dairy or plant-based milk',
    'Chocolate em Pó': 'Chocolate powder', 'Baunilha': 'Vanilla', 'Leite Integral (3%)': 'Whole milk (3%)', 'Leite de Aveia': 'Oat milk',
    'Leite de Aveia (Nude)': 'Nude oat milk', 'Gingibre Extra': 'Extra ginger', 'Maçã com Canela': 'Apple and cinnamon',
    'Laranja com Canela': 'Orange and cinnamon', 'Camomila': 'Chamomile', 'Frutas Vermelhas': 'Red berries', 'Frutas Silvestres': 'Wild berries',
    'Limão com Gengibre': 'Lemon and ginger', 'Chá Verde': 'Green tea', 'Açucar +5g': 'Sugar +5g', '+1 Gotinha (Sucrulose)': '1 drop of sucralose',
    'Quente': 'Hot', 'Frio': 'Iced', 'Sem mel': 'No honey', 'Mel extra': 'Extra honey', 'Leite Integral': 'Whole milk', 'Leite Vegano': 'Plant-based milk'
  };
  const optionLabel = (value) => lang === 'en' ? (englishLabels[value] || value) : value;
  let lang = 'pt';
  try { lang = localStorage.getItem('aussie-menu-language') === 'en' ? 'en' : 'pt'; } catch (_) { /* Storage is optional. */ }
  let query = '';
  let currentItem = null;
  let productPinch = null;
  let detailScrollY = 0;
  let detailCloseTimer;
  let categoryObserver;
  let categoryGesture = null;
  let suppressSwipeClickUntil = 0;
  let activeCategoryId = String(data.categories[0].id);
  let categorySizeObserver;
  let releaseSliderHeight = null;
  const mobileCategories = window.matchMedia('(max-width: 749px)');
  const products = data.categories.flatMap((category) => category.products.map((product) => ({...product, category})));
  const productById = new Map(products.map((product) => [product.id, product]));
  const featuredIds = [180, 193, 377, 211, 181, 195, 207, 210];
  const escape = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[character]));
  const fold = (value) => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const t = (key) => messages[lang][key];
  const categoryName = (category) => lang === 'en' ? category.name_en : category.name;
  const description = (product) => product[`description_${lang}`] || product.description_pt || product.description_en || '';
  const money = (price) => new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(price);
  const imageUrl = (product) => `${root.dataset.assetBase}${product.image}`;
  const priceHtml = (product) => `<span class="ac-price">${product.from_price ? `<small>${t('from')} </small>` : ''}${escape(money(product.price))}</span>`;
  const imageHtml = (product, className = '') => product.image ? `<img class="${className}" src="${escape(imageUrl(product))}" alt="${escape(product.name)}" loading="lazy" decoding="async" draggable="false" width="400" height="400">` : '';
  const productHtml = (product, featured = false) => {
    const itemName = product.kind === 'donation' ? (lang === 'en' ? 'Estrela da Favela · R$100 donation' : 'Estrela da Favela · Doação de R$100') : product.name;
    if (featured) return `<button class="ac-feature-card" type="button" data-product="${product.id}" aria-haspopup="dialog" aria-controls="item-dialog" aria-label="${escape(`${t('viewDetails')} ${itemName}`)}">${imageHtml(product)}<span class="ac-feature-body"><h3>${escape(itemName)}</h3>${priceHtml(product)}<span class="ac-card-arrow" aria-hidden="true">↗</span></span></button>`;
    return `<button class="ac-product${product.image ? '' : ' ac-product--no-image'}" type="button" data-product="${product.id}" aria-haspopup="dialog" aria-controls="item-dialog" aria-label="${escape(`${t('viewDetails')} ${itemName}`)}"><span class="ac-product-copy"><h3>${escape(itemName)}</h3>${priceHtml(product)}</span>${imageHtml(product, 'ac-product-image')}<span class="ac-product-plus" aria-hidden="true">↗</span></button>`;
  };
  function matches(product, category) {
    const haystack = fold([product.name, product.description_pt, product.description_en, category.name, category.name_en, ...product.groups.flatMap((group) => group.options.map((option) => `${option.name} ${englishLabels[option.name] || ''} ${option.description || ''}`))].join(' '));
    return fold(query).split(/\s+/).filter(Boolean).every((word) => haystack.includes(word));
  }
  function activateCategory(id) {
    activeCategoryId = String(id);
    $$('#category-nav a').forEach((link) => {
      const active = link.dataset.category === String(id);
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
    });
  }
  function observeCategories() {
    categoryObserver?.disconnect();
    if (mobileCategories.matches && !query) return;
    const headerHeight = $('.ac-menu-header').getBoundingClientRect().height;
    categoryObserver = new IntersectionObserver((entries) => {
      const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      if (visible.length) activateCategory(visible[0].target.dataset.category);
    }, {rootMargin: `-${headerHeight + 75}px 0px -50% 0px`, threshold: 0});
    $$('.ac-category-section').forEach((section) => categoryObserver.observe(section));
  }
  function renderCatalog() {
    let count = 0;
    $('#menu-sections').innerHTML = data.categories.map((category) => {
      const filtered = category.products.filter((product) => matches(product, category));
      count += filtered.length;
      if (!filtered.length) return '';
      return `<section class="ac-category-section" data-category="${category.id}" id="categoria-${category.id}" aria-labelledby="category-heading-${category.id}"><div class="ac-section-heading"><div><h2 id="category-heading-${category.id}">${escape(categoryName(category))}</h2><p class="ac-category-intro">${escape(t('intros')[category.id] || '')}</p></div><span class="ac-category-count">${filtered.length} ${t('itemCount')}</span></div><div class="ac-product-grid">${filtered.map((product) => productHtml(product)).join('')}</div></section>`;
    }).join('');
    $('.ac-featured').hidden = Boolean(query);
    $('#empty-results').hidden = count > 0;
    $('#search-status').hidden = !query;
    $('#search-status').textContent = `${count} ${t('results')} “${query}”`;
    $('#clear-search').hidden = !query;
    $('#category-swipe-hint').hidden = Boolean(query);
    categoryGesture = null;
    releaseSliderHeight?.();
    $('.ac-catalog').classList.remove('is-dragging');
    positionCategorySlider();
    categorySizeObserver?.disconnect();
    categorySizeObserver = new ResizeObserver(() => {
      if (!categoryGesture?.horizontal && !releaseSliderHeight) positionCategorySlider();
    });
    $$('.ac-category-section').forEach((section) => categorySizeObserver.observe(section));
    observeCategories();
  }
  function renderNavigation() {
    const links = data.categories.map((category) => `<a href="#categoria-${category.id}" data-category="${category.id}">${escape(categoryName(category))}</a>`).join('');
    $('#category-nav').innerHTML = links;
    $('#category-list').innerHTML = data.categories.map((category) => `<a href="#categoria-${category.id}" data-category="${category.id}"><span>${escape(categoryName(category))}</span><span aria-hidden="true">↗</span></a>`).join('');
    activateCategory(activeCategoryId);
  }
  function localize() {
    document.documentElement.lang = lang === 'en' ? 'en' : 'pt-BR';
    $$('[data-i18n]').forEach((element) => { element.textContent = t(element.dataset.i18n); });
    $$('[data-tile-pt]').forEach((element) => { element.textContent = (lang === 'en' && element.dataset.tileEn) || element.dataset.tilePt; });
    $$('[data-i18n-html]').forEach((element) => { element.innerHTML = t(element.dataset.i18nHtml); });
    $$('[data-i18n-placeholder]').forEach((element) => { element.placeholder = t(element.dataset.i18nPlaceholder); });
    $$('[data-lang]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.lang === lang)));
    $('#open-categories').setAttribute('aria-label', t('allCategories'));
    $('#clear-search').setAttribute('aria-label', t('clearSearch'));
    $$('#category-dialog [data-close-dialog]').forEach((button) => button.setAttribute('aria-label', t('closeCategories')));
    $$('#item-dialog [data-close-dialog]').forEach((button) => button.setAttribute('aria-label', t('close')));
    $('#featured-products').innerHTML = featuredIds.map((id) => productById.get(id)).filter(Boolean).map((product) => productHtml(product, true)).join('');
    renderNavigation();
    renderCatalog();
    if (currentItem) renderDetail(currentItem);
    refreshCommunitySearch();
    renderConnectionCheck();
    renderSpeedFollowups();
    localizeCaipibara();
    window.AussieFeedbackPhone?.localize(lang);
  }
  function renderDetail(product) {
    const name = product.kind === 'donation' ? (lang === 'en' ? 'Estrela da Favela · R$100 donation' : 'Estrela da Favela · Doação de R$100') : product.name;
    $('#item-detail').innerHTML = `${imageHtml(product, 'ac-dialog-image')}<div class="ac-dialog-body"><span class="ac-eyebrow">${escape(categoryName(product.category))}</span><h2 id="item-title">${escape(name)}</h2>${priceHtml(product)}<p class="ac-detail-description" id="item-description">${escape(description(product))}</p>${product.groups.length ? `<div class="ac-options">${product.groups.map((group) => `<fieldset><legend>${escape(optionLabel(group.name))} <small>${group.optional ? t('optional') : t('choose')}</small></legend>${group.options.map((option) => `<div class="ac-option-row"><span>${escape(optionLabel(option.name))}${option.description ? `<small>${escape(option.description)}</small>` : ''}</span><strong>${option.price > 0 ? `+ ${escape(money(option.price))}` : t('included')}</strong></div>`).join('')}</fieldset>`).join('')}</div>` : ''}<div class="ac-dialog-footer"><svg aria-hidden="true"><use href="#ac-icon-cup"/></svg><p>${product.kind === 'donation' ? t('donationNote') : t('detailNote')}</p></div></div>`;
  }
  function showItem(id) {
    currentItem = productById.get(Number(id));
    if (!currentItem) return;
    detailScrollY = window.scrollY;
    clearTimeout(detailCloseTimer);
    $('#item-dialog').classList.remove('is-zoom-closing');
    renderDetail(currentItem);
    $('#item-dialog').showModal();
    $('#item-dialog').scrollTop = 0;
  }
  function closeZoomedItem() {
    const dialog = $('#item-dialog');
    if (!dialog.open || dialog.classList.contains('is-zoom-closing')) return;
    dialog.classList.add('is-zoom-closing');
    detailCloseTimer = setTimeout(() => dialog.close(), window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 360);
  }
  function resetSearch() {
    query = '';
    $('#menu-search').value = '';
    renderCatalog();
  }
  function sliderTop() {
    return $('.ac-menu-header').getBoundingClientRect().height + $('.ac-category-bar').getBoundingClientRect().height + 24;
  }
  function positionCategorySlider(offset = 0, holdHeight = false) {
    const catalog = $('.ac-catalog');
    const stage = $('.ac-category-stage');
    const track = $('#menu-sections');
    const sections = $$('.ac-category-section');
    const paged = mobileCategories.matches && !query;
    catalog.classList.toggle('ac-catalog--paged', paged);
    // A focused item must not add native horizontal scrolling on top of the
    // slider transform (notably when Safari restores focus after a dialog).
    if (stage.scrollLeft) stage.scrollLeft = 0;
    sections.forEach((section) => { section.inert = paged && section.dataset.category !== activeCategoryId; });
    if (!paged) {
      track.style.removeProperty('transform');
      track.style.removeProperty('--ac-category-heading-height');
      stage.style.removeProperty('height');
      releaseSliderHeight?.();
      return;
    }
    let index = sections.findIndex((section) => section.dataset.category === activeCategoryId);
    if (index < 0) { index = 0; activateCategory(sections[0]?.dataset.category); }
    if (!sections[index]) return;
    track.style.transform = `translate3d(calc(-${index * 100}% + ${offset}px), 0, 0)`;
    if (categoryGesture?.horizontal) return;
    // Category titles and introductions wrap differently. Reserve the same
    // natural header height in every panel so image rows line up while sliding.
    const headingHeight = Math.ceil(Math.max(...sections.map((section) => {
      const heading = section.querySelector('.ac-section-heading');
      return Math.max(...[...heading.children].map((child) => child.getBoundingClientRect().height));
    })));
    if (headingHeight) track.style.setProperty('--ac-category-heading-height', `${headingHeight}px`);
    const height = Math.ceil(Math.max(sections[index].getBoundingClientRect().height, window.innerHeight - sliderTop()));
    if (holdHeight && stage.getBoundingClientRect().height > height) {
      // Keep enough page height while a deeply scrolled category returns to its
      // top, so switching to a short category cannot clamp the page abruptly.
      releaseSliderHeight?.();
      const cleanup = () => {
        clearTimeout(timer);
        window.removeEventListener('scrollend', finish);
        releaseSliderHeight = null;
      };
      const finish = () => { cleanup(); positionCategorySlider(); };
      const timer = setTimeout(finish, 1000);
      releaseSliderHeight = cleanup;
      window.addEventListener('scrollend', finish, {once: true});
    } else if (!releaseSliderHeight) stage.style.height = `${height}px`;
  }
  function scrollToCategory(id, fromSwipe = false) {
    if (query) resetSearch();
    const target = $(`#categoria-${id}`);
    if (!target) return;
    history.replaceState(null, '', `#categoria-${id}`);
    if (mobileCategories.matches) {
      const track = $('#menu-sections');
      const sections = $$('.ac-category-section');
      const index = sections.indexOf(target);
      const width = $('.ac-category-stage').clientWidth;
      const currentX = new DOMMatrixReadOnly(getComputedStyle(track).transform).m41;
      const remaining = Math.abs(-index * width - currentX);
      // One panel takes 650ms. Scale release time by the distance remaining so
      // a small swipe and a long swipe settle at the same steady speed.
      const duration = fromSwipe && width ? Math.max(80, remaining / width * 650) : 650;
      track.style.setProperty('--ac-category-transition-duration', `${Math.round(duration)}ms`);
    }
    activateCategory(id);
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    if (mobileCategories.matches) {
      const stage = $('.ac-category-stage');
      const needsTop = stage.getBoundingClientRect().top < sliderTop() - 32;
      releaseSliderHeight?.();
      positionCategorySlider(0, needsTop);
      if (!fromSwipe || needsTop) stage.scrollIntoView({behavior, block: 'start'});
    } else target.scrollIntoView({behavior, block: 'start'});
    const navLink = $(`#category-nav a[data-category="${id}"]`);
    if (navLink) {
      const nav = $('#category-nav');
      nav.scrollTo({left: navLink.offsetLeft - nav.offsetLeft - 16, behavior});
    }
  }
  let communityArtworkFrame = 0;
  let communityWallpaperSlots = [];
  function updateCommunityArtwork() {
    communityArtworkFrame = 0;
    const community = $('#community-view');
    if (community.hidden) return;
    const wallpaper = $('.ac-community-wallpaper');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!communityWallpaperSlots.length) {
      const originals = [...wallpaper.querySelectorAll('img')].map((image) => image.src);
      communityWallpaperSlots = Array.from({length: 12}, (_, index) => {
        const element = document.createElement('span');
        element.className = 'ac-rio-art';
        wallpaper.append(element);
        return {element, originals, index};
      });
    }
    const travel = Math.max(0, window.scrollY - community.offsetTop) / Math.max(600, innerHeight * 0.85);
    communityWallpaperSlots.forEach(({element, originals, index}) => {
      const phase = (reduced ? 0.5 : travel) + index / 12;
      const cycle = Math.floor(phase);
      const progress = phase - cycle;
      const item = (index + cycle * 12) % 28;
      const column = (index % 3 + cycle) % 3;
      const row = Math.floor(index / 3);
      const jitter = ((index * 17 + cycle * 11) % 13) - 6;
      element.style.left = `${8 + column * 32 + jitter}%`;
      element.style.top = `${10 + row * 24 + ((index * 7 + cycle * 3) % 9)}%`;
      element.style.transform = `translate(-50%, -50%) rotate(${((index * 11 + cycle * 7) % 19) - 9}deg)`;
      element.style.opacity = reduced ? '0.24' : (Math.pow(Math.sin(Math.PI * progress), 1.5) * 0.34).toFixed(3);
      if (item < 21) {
        element.style.backgroundImage = `url("${wallpaper.dataset.rioSprites}")`;
        element.style.backgroundSize = '500% 500%';
        element.style.clipPath = 'inset(8% round 8%)';
        element.style.backgroundPosition = `${(item % 5) * 25}% ${Math.floor(item / 5) * 25}%`;
      } else {
        element.style.backgroundImage = `url("${originals[item - 21]}")`;
        element.style.backgroundSize = 'contain';
        element.style.clipPath = 'none';
        element.style.backgroundPosition = 'center';
      }
    });
  }
  const welcomePreview = $('[data-menu-preview]');
  const welcomeFeature = $('[data-menu-feature]');
  const welcomePreviewMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const welcomeDishes = [180, 181, 183, 210, 211].map((id) => productById.get(id)).filter((product) => product?.image);
  let welcomeDishIndex = 0;
  let welcomePreviewTimer;
  let welcomePreviewHovered = false;
  function syncWelcomePreview() {
    clearTimeout(welcomePreviewTimer);
    if (welcomeDishes.length < 2 || welcomePreviewHovered || welcomePreviewMotion.matches || document.hidden || $('#welcome').hidden || welcomeFeature.querySelector('a') === document.activeElement) return;
    welcomePreviewTimer = setTimeout(() => {
      welcomeDishIndex = (welcomeDishIndex + 1) % welcomeDishes.length;
      [...welcomePreview.children].forEach((image, index) => image.classList.toggle('is-current', index === welcomeDishIndex));
        syncWelcomePreview();
    }, 4500);
  }
  welcomeDishes.slice(1).forEach((product) => {
    const image = document.createElement('img');
    image.className = 'ac-menu-preview-slide';
    image.alt = '';
    image.width = 400;
    image.height = 400;
    image.decoding = 'async';
    image.src = imageUrl(product);
    welcomePreview.append(image);
  });
  welcomeFeature.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') { welcomePreviewHovered = true; syncWelcomePreview(); } });
  welcomeFeature.addEventListener('pointerleave', () => { welcomePreviewHovered = false; syncWelcomePreview(); });
  welcomeFeature.addEventListener('focusin', syncWelcomePreview);
  welcomeFeature.addEventListener('focusout', () => requestAnimationFrame(syncWelcomePreview));
  document.addEventListener('visibilitychange', syncWelcomePreview);
  welcomePreviewMotion.addEventListener('change', () => { welcomePreviewToggle.hidden = welcomeDishes.length < 2 || welcomePreviewMotion.matches; syncWelcomePreview(); });
  const connectionTile = $('[data-connection-tile]');
  const connectionRetry = $('[data-connection-retry]');
  const speedStickers = $('[data-speed-stickers]');
  const stickerMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pageSticker = 'dog-large';
  let stickerLoad;
  let stickerStarted = false;
  function loadSpeedStickers() {
    if (!stickerLoad) stickerLoad = (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 6000);
      let objectUrl;
      try {
        // One character for this page load; fetch it before measuring bandwidth.
        const response = await fetch(`${root.dataset.assetBase}ac-speed-${pageSticker}.gif`, {signal: controller.signal});
        if (!response.ok) return;
        objectUrl = URL.createObjectURL(await response.blob());
        const img = new Image();
        img.alt = '';
        img.dataset.source = response.url;
        img.src = objectUrl;
        await img.decode();
        speedStickers.append(img);
      } catch (_) {
        if (objectUrl) URL.revokeObjectURL(objectUrl);
      } finally { clearTimeout(timeout); }
    })();
    return stickerLoad;
  }
  function startSpeedStickers() {
    speedStickers.hidden = !stickerStarted || stickerMotion.matches || !speedStickers.children.length;
  }
  stickerMotion.addEventListener('change', async () => {
    if (!stickerMotion.matches) await loadSpeedStickers();
    startSpeedStickers();
  });

  let connectionState = 'waiting';
  let connectionPhase = 'response';
  let connectionDownload = null;
  let connectionLatency = null;
  function renderConnectionCheck() {
    const number = (value, digits) => new Intl.NumberFormat(lang === 'en' ? 'en-GB' : 'pt-BR', {maximumFractionDigits: digits}).format(value);
    $('[data-connection-download]').textContent = connectionDownload === null ? '—' : `≈${number(connectionDownload, connectionDownload < 10 ? 1 : 0)}`;
    const stateKeys = {waiting: 'connectionWaiting', running: connectionPhase === 'response' ? 'connectionWarming' : 'connectionRunning', complete: 'connectionComplete', offline: 'connectionOffline', error: 'connectionError'};
    $('[data-connection-status]').textContent = connectionState === 'complete' ? '' : t(stateKeys[connectionState]);
    $('[data-connection-status]').classList.toggle('ac-sr-only', !['offline', 'error'].includes(connectionState));
    $('[data-connection-button-label]').textContent = connectionState === 'complete' ? '↻' : t(connectionState === 'running' ? 'connectionTesting' : connectionState === 'waiting' ? 'connectionStart' : 'connectionRetry');
    connectionRetry.setAttribute('aria-label', t(connectionState === 'waiting' ? 'connectionStart' : 'connectionRetry'));
    connectionTile.classList.toggle('has-started', stickerStarted);
    connectionTile.classList.toggle('is-testing', connectionState === 'running');
    connectionTile.classList.toggle('is-warming-up', connectionState === 'running' && connectionPhase === 'response');
    connectionTile.classList.toggle('has-result', connectionState === 'complete');
    connectionTile.classList.toggle('has-error', ['error', 'offline'].includes(connectionState));
    connectionRetry.title = t('connectionRetry');
    $('[data-speed-instagram]').disabled = connectionState !== 'complete' || !speedResultUrl;
    const whatsapp = $('[data-speed-whatsapp]');
    whatsapp.disabled = connectionState !== 'complete' || !speedResultFile;
    const dial = connectionDownload === null ? 0 : Math.min(1, Math.log10(1 + Math.max(0, connectionDownload)) / Math.log10(1001));
    connectionTile.style.setProperty('--ac-speed-fill', String(dial * 100));
    connectionRetry.disabled = connectionState === 'running' || (connectionState === 'waiting' && !stickerStarted);
    $('[data-connection-start]').disabled = connectionState === 'running';
  }
  let connectionController = null;
  let connectionRunToken = 0;
  let speedShareDownload = null;
  function connectionShouldRun() {
    return !document.hidden && !$('#welcome').hidden && navigator.onLine;
  }
  function syncAutomaticConnection() {
    if (!connectionShouldRun()) {
      connectionRunToken++;
      connectionController?.abort();
    }
  }
  document.addEventListener('visibilitychange', syncAutomaticConnection);
  window.addEventListener('online', syncAutomaticConnection);
  window.addEventListener('offline', syncAutomaticConnection);
  window.addEventListener('pagehide', () => connectionController?.abort());
  window.addEventListener('pageshow', syncAutomaticConnection);
  async function runConnectionCheck() {
    if (connectionState === 'running' || document.hidden || $('#welcome').hidden) return;
    resetSpeedFollowups();
    const runToken = ++connectionRunToken;
    connectionLatency = null;
    connectionPhase = 'response';
    if (!navigator.onLine) { connectionState = 'offline'; renderConnectionCheck(); return; }
    connectionState = 'running';
    stickerStarted = true;
    renderConnectionCheck();
    if (!stickerMotion.matches) await loadSpeedStickers();
    if (runToken !== connectionRunToken || !connectionShouldRun()) {
      connectionState = 'waiting';
      renderConnectionCheck();
      return;
    }
    startSpeedStickers();
    const controller = new AbortController();
    connectionController = controller;
    const watchdog = setTimeout(() => controller.abort(), 20000);
    const measurementDuration = 5000;
    let windowTimer;
    let measurementStart = null;
    let measurementComplete = false;
    let downloadedBytes = 0;
    let lastReadout = 0;
    const sampleUrl = (filename) => {
      const url = new URL(`${root.dataset.assetBase}${filename}`, location.href);
      url.searchParams.set('ac_connection_check', `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      return url;
    };
    const fetchOptions = {cache: 'no-store', credentials: 'omit', signal: controller.signal};
    const finishWindow = () => { measurementComplete = true; controller.abort(); };
    const streamDownload = async () => {
      // Three continuous streams reduce the gaps between asset requests.
      while (!controller.signal.aborted) {
        const response = await fetch(sampleUrl('ac-rio-wallpaper-sprites.png'), fetchOptions);
        if (!response.ok || !response.body?.getReader) throw new Error('Connection stream unavailable');
        const reader = response.body.getReader();
        while (!controller.signal.aborted) {
          const chunk = await reader.read();
          if (chunk.done) break;
          const now = performance.now();
          if (measurementStart === null) {
            // Start the measurement on the first bytes, after connection setup.
            measurementStart = now;
            windowTimer = setTimeout(finishWindow, measurementDuration);
          }
          const elapsed = now - measurementStart;
          if (elapsed >= measurementDuration) { finishWindow(); return; }
          downloadedBytes += chunk.value.byteLength;
          if (elapsed >= 200 && now - lastReadout >= 150) {
            connectionDownload = downloadedBytes * 8 / (elapsed / 1000) / 1000000;
            $('[data-connection-button-label]').textContent = `${t('connectionTesting')} ${Math.max(1, Math.ceil((measurementDuration - elapsed) / 1000))}s`;
            updateConnectionDial();
            lastReadout = now;
          }
        }
      }
    };
    try {
      const responses = [];
      for (let i = 0; i < 2; i++) {
        const start = performance.now();
        const response = await fetch(sampleUrl('aussie-coffee-favicon.jpg'), fetchOptions);
        if (!response.ok) throw new Error('Connection response unavailable');
        await response.arrayBuffer();
        responses.push(performance.now() - start);
      }
      connectionLatency = responses.reduce((sum, value) => sum + value, 0) / responses.length;
      connectionPhase = 'download';
      renderConnectionCheck();
      await Promise.allSettled(Array.from({length: 3}, streamDownload));
      if (!measurementComplete || downloadedBytes < 100000) throw new Error('Incomplete measurement window');
      connectionDownload = downloadedBytes * 8 / (measurementDuration / 1000) / 1000000;
      connectionState = 'complete';
    } catch (_) {
      connectionState = !connectionShouldRun() ? 'waiting' : navigator.onLine ? 'error' : 'offline';
    } finally {
      controller.abort();
      if (connectionController === controller) connectionController = null;
      clearTimeout(watchdog);
      clearTimeout(windowTimer);
      renderConnectionCheck();
      if (connectionState === 'complete') { speedShareDownload = connectionDownload; renderSpeedFollowups(); }
    }
  }
  function updateConnectionDial() {
    const number = new Intl.NumberFormat(lang === 'en' ? 'en-GB' : 'pt-BR', {maximumFractionDigits: connectionDownload < 10 ? 1 : 0}).format(connectionDownload);
    $('[data-connection-download]').textContent = `≈${number}`;
    const dial = Math.min(1, Math.log10(1 + Math.max(0, connectionDownload)) / Math.log10(1001));
    connectionTile.style.setProperty('--ac-speed-fill', String(dial * 100));
  }
  connectionRetry.addEventListener('click', runConnectionCheck);
  $('[data-connection-start]').addEventListener('click', runConnectionCheck);
  let speedResultFile = null;
  let speedResultUrl = null;
  let speedResultKey = null;
  const speedShareUrl = 'https://aussiecoffee.com.br/pages/welcome';
  function speedShareText() {
    const speed = new Intl.NumberFormat(lang === 'en' ? 'en-GB' : 'pt-BR', {maximumFractionDigits: speedShareDownload < 10 ? 1 : 0}).format(speedShareDownload);
    return lang === 'en'
      ? `☕ My Rio connection: ≈${speed} Mbps! A 5-second download average in the Aussie Coffee Wi-Fi Speed Test. Coffee, remote work & digital nomad life in Rio de Janeiro. Test your connection:`
      : `☕ Minha conexão no Rio: ≈${speed} Mbps! Média de download em 5 segundos no teste de Wi-Fi da Aussie Coffee. Café, trabalho remoto e vida nômade no Rio de Janeiro. Teste sua conexão:`;
  }
  function buildSpeedResultCard(speed) {
    const key = `${lang}:${speedShareDownload}`;
    if (key === speedResultKey) return;
    speedResultKey = key;
    $('[data-speed-instagram]').disabled = true;
    $('[data-speed-whatsapp]').disabled = true;
    speedResultFile = null;
    const canvas = document.createElement('canvas');
    canvas.width = 1080;
    canvas.height = 1350;
    const ctx = canvas.getContext('2d');
    const ink = '#102855', blue = '#1762ee', cream = '#fff7dc', yellow = '#ffe15b';
    ctx.fillStyle = blue; ctx.fillRect(0, 0, 1080, 1350);
    // Café-poster shapes: sunshine, hand-drawn waves, punchy type and paper badges.
    ctx.fillStyle = yellow; ctx.beginPath(); ctx.arc(975, 65, 180, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = ink;
    for (let i = 0; i < 12; i++) {
      ctx.save(); ctx.translate(975, 65); ctx.rotate(i * Math.PI / 6);
      ctx.fillRect(195, -5, 35, 10); ctx.restore();
    }
    const label = (text, x, y, width, angle, fill, size) => {
      ctx.save(); ctx.translate(x, y); ctx.rotate(angle);
      ctx.fillStyle = ink; ctx.fillRect(-width / 2 + 8, -38 + 8, width, 76);
      ctx.fillStyle = fill; ctx.fillRect(-width / 2, -38, width, 76);
      ctx.strokeStyle = ink; ctx.lineWidth = 4; ctx.strokeRect(-width / 2, -38, width, 76);
      ctx.fillStyle = ink; ctx.textAlign = 'center'; ctx.font = `bold ${size}px sans-serif`; ctx.fillText(text, 0, 12, width - 30); ctx.restore();
    };
    ctx.textAlign = 'left'; ctx.fillStyle = cream; ctx.font = 'bold 54px sans-serif'; ctx.fillText('AUSSIE COFFEE', 65, 115);
    ctx.font = '23px sans-serif'; ctx.fillText('RIO DE JANEIRO / DIGITAL NOMAD LIFE', 65, 164);
    label('Aussie Coffee Fibre Optic', 525, 270, 900, -.045, yellow, 48);
    ctx.fillStyle = cream; ctx.strokeStyle = ink; ctx.lineWidth = 6;
    ctx.beginPath(); ctx.roundRect(75, 355, 930, 535, 65); ctx.fill(); ctx.stroke();
    ctx.strokeStyle = blue; ctx.lineWidth = 20; ctx.lineCap = 'round';
    ctx.beginPath(); ctx.arc(540, 640, 220, Math.PI * 1.1, Math.PI * 1.9); ctx.stroke();
    ctx.fillStyle = ink; ctx.textAlign = 'center'; ctx.font = 'bold 150px sans-serif'; ctx.fillText(`≈${speed}`, 540, 660, 800);
    ctx.font = 'bold 40px sans-serif'; ctx.fillText('Mbps', 540, 720);
    ctx.font = 'bold 26px sans-serif'; ctx.fillText(lang === 'en' ? 'MY WI-FI SPEED SCORE' : 'MEU RESULTADO DE WI-FI', 540, 792);
    ctx.font = '23px sans-serif'; ctx.fillText(lang === 'en' ? 'Estimated download / 5-second average' : 'Download estimado / média de 5 segundos', 540, 839);
    label(lang === 'en' ? 'COFFEE-POWERED' : 'MOVIDO A CAFÉ', 540, 938, 560, .045, '#b7e5ff', 34);
    ctx.fillStyle = cream; ctx.font = 'bold 51px sans-serif';
    ctx.fillText(lang === 'en' ? 'Less office. More Rio.' : 'Menos escritório. Mais Rio.', 540, 1070, 950);
    ctx.font = '26px sans-serif'; ctx.fillText(lang === 'en' ? 'Coffee, connection & a little gingado.' : 'Café, conexão e um pouco de gingado.', 540, 1122);
    ctx.strokeStyle = '#80c9ff'; ctx.lineWidth = 5;
    for (let i = 0; i < 3; i++) {
      ctx.beginPath(); ctx.moveTo(0, 1180 + i * 22);
      for (let x = 0; x < 1080; x += 180) { ctx.quadraticCurveTo(x + 45, 1155 + i * 22, x + 90, 1180 + i * 22); ctx.quadraticCurveTo(x + 135, 1205 + i * 22, x + 180, 1180 + i * 22); }
      ctx.stroke();
    }
    ctx.fillStyle = cream; ctx.font = 'bold 30px sans-serif'; ctx.fillText('aussiecoffee.com.br', 540, 1290);
    canvas.toBlob(blob => {
      if (!blob || key !== speedResultKey) return;
      if (speedResultUrl) URL.revokeObjectURL(speedResultUrl);
      speedResultUrl = URL.createObjectURL(blob);
      speedResultFile = new File([blob], 'aussie-coffee-rio-wifi-score.png', {type: 'image/png'});
      $('[data-speed-whatsapp]').disabled = connectionState !== 'complete';
      $('[data-speed-instagram]').disabled = connectionState !== 'complete';
    }, 'image/png');
  }
  function renderSpeedFollowups() {
    if (speedShareDownload === null) return;
    const speed = new Intl.NumberFormat(lang === 'en' ? 'en-GB' : 'pt-BR', {maximumFractionDigits: speedShareDownload < 10 ? 1 : 0}).format(speedShareDownload);
    $('[data-speed-whatsapp]').title = lang === 'en' ? 'Share result image — choose WhatsApp' : 'Compartilhar imagem — escolha WhatsApp';
    $('[data-speed-whatsapp]').setAttribute('aria-label', $('[data-speed-whatsapp]').title);
    $('[data-speed-instagram]').title = lang === 'en' ? 'Share result image — choose Instagram' : 'Compartilhar imagem — escolha Instagram';
    $('[data-speed-instagram]').setAttribute('aria-label', $('[data-speed-instagram]').title);
    buildSpeedResultCard(speed);
  }
  function resetSpeedFollowups() {
    speedShareDownload = null;
    speedResultKey = null;
    if (speedResultUrl) URL.revokeObjectURL(speedResultUrl);
    speedResultUrl = null;
    speedResultFile = null;
    $('[data-speed-social-note]').hidden = true;
  }
  $('[data-speed-instagram]').addEventListener('click', async () => {
    if (connectionState !== 'complete' || !speedResultFile) return;
    const note = $('[data-speed-social-note]');
    if (navigator.share && navigator.canShare?.({files: [speedResultFile]})) {
      try {
        await navigator.share({files: [speedResultFile], title: 'Aussie Coffee · Wi-Fi speed result'});
        note.hidden = true;
        return;
      } catch (error) {
        if (error.name === 'AbortError') return;
      }
    }
    const download = document.createElement('a');
    download.href = speedResultUrl;
    download.download = 'aussie-coffee-rio-wifi-score.png';
    root.append(download);
    download.click();
    download.remove();
    note.textContent = lang === 'en' ? 'Image sharing isn’t available in this browser. Result downloaded — upload the image in Instagram.' : 'Este navegador não permite compartilhar imagens. Resultado baixado — adicione a imagem no Instagram.';
    note.hidden = false;
  });
  $('[data-speed-whatsapp]').addEventListener('click', async () => {
    if (connectionState !== 'complete' || !speedResultFile) return;
    const note = $('[data-speed-social-note]');
    if (navigator.share && navigator.canShare?.({files: [speedResultFile]})) {
      try {
        await navigator.share({files: [speedResultFile], title: 'Aussie Coffee · Wi-Fi speed result'});
        note.hidden = true;
        return;
      } catch (error) {
        if (error.name === 'AbortError') return;
      }
    }
    const download = document.createElement('a');
    download.href = speedResultUrl;
    download.download = 'aussie-coffee-rio-wifi-score.png';
    root.append(download);
    download.click();
    download.remove();
    note.textContent = lang === 'en' ? 'Image sharing isn’t available in this browser. Result downloaded — attach the image in WhatsApp.' : 'Este navegador não permite compartilhar imagens. Resultado baixado — anexe a imagem no WhatsApp.';
    note.hidden = false;
  });
  function applyRoute() {
    const inMenu = location.hash === '#cardapio' || location.hash.startsWith('#categoria-');
    const inCommunity = location.hash === '#comunidade';
    const inRolezinho = location.hash === '#rolezinho';
    $('#rolezinho-view').hidden = !inRolezinho;
    $('#community-view').hidden = !inCommunity;
    $('#welcome').hidden = inMenu || inCommunity || inRolezinho;
    $('#menu-view').hidden = !inMenu;
    syncWelcomePreview();
    syncAutomaticConnection();
    document.title = `${location.hash === '#rolezinho' ? (lang === 'en' ? 'My Rio rolezinho' : 'Meu rolezinho no Rio') : location.hash === '#comunidade' ? t('communityTitle') : (lang === 'en' ? 'Menu' : 'Cardápio')} · Aussie Coffee`;
    if (inMenu) {
      requestAnimationFrame(() => {
        updateHeaderHeight();
        positionCategorySlider();
        observeCategories();
        if (location.hash.startsWith('#categoria-')) scrollToCategory(location.hash.replace('#categoria-', ''));
        else window.scrollTo({top: 0, behavior: 'instant'});
      });
    } else window.scrollTo({top: 0, behavior: 'instant'});
    if (inCommunity) {
      communityArtworkFrame = requestAnimationFrame(updateCommunityArtwork);
    }
  }
  function updateHeaderHeight() {
    const height = $('.ac-menu-header').getBoundingClientRect().height;
    if (height) root.style.setProperty('--ac-menu-header-height', `${Math.ceil(height)}px`);
  }
  function cancelCategoryGesture() {
    categoryGesture = null;
    $('.ac-catalog').classList.remove('is-dragging');
    positionCategorySlider();
  }
  // The track follows the finger, then settles onto one full category. Native
  // vertical scrolling and pinch zoom remain available throughout the catalog.
  root.addEventListener('pointerdown', (event) => {
    suppressSwipeClickUntil = 0;
    if (!event.isPrimary) cancelCategoryGesture();
  }, true);
  $('.ac-category-stage').addEventListener('pointerdown', (event) => {
    $('.ac-catalog').classList.add('has-interacted');
    if (!event.isPrimary) return;
    if (!mobileCategories.matches || event.button !== 0 || $$('dialog[open]').length) return;
    const section = event.target.closest('.ac-category-section');
    if (query && !section) return;
    categoryGesture = {pointerId: event.pointerId, x: event.clientX, y: event.clientY, dx: 0, category: query ? section.dataset.category : activeCategoryId, horizontal: false, offset: 0};
  });
  window.addEventListener('pointermove', (event) => {
    if (!categoryGesture || event.pointerId !== categoryGesture.pointerId) return;
    const dx = event.clientX - categoryGesture.x;
    const dy = Math.abs(event.clientY - categoryGesture.y);
    if (dx !== 0) categoryGesture.dx = dx;
    if (!categoryGesture.horizontal && dy > 12 && dy > Math.abs(dx)) { cancelCategoryGesture(); return; }
    if (!categoryGesture.horizontal && Math.abs(dx) >= 2 && Math.abs(dx) > dy) {
      categoryGesture.horizontal = true;
      const stage = $('.ac-category-stage');
      if (stage.setPointerCapture) {
        try { stage.setPointerCapture(event.pointerId); } catch (_) { /* The pointer may already have ended. */ }
      }
      if (!query) {
        const sections = $$('.ac-category-section');
        const index = sections.findIndex((section) => section.dataset.category === activeCategoryId);
        const transform = new DOMMatrixReadOnly(getComputedStyle($('#menu-sections')).transform);
        categoryGesture.offset = transform.m41 + index * $('.ac-category-stage').clientWidth;
      }
    }
    if (categoryGesture.horizontal) {
      if (event.cancelable) event.preventDefault();
      if (query) return;
      $('.ac-catalog').classList.add('is-dragging');
      const sections = $$('.ac-category-section');
      const index = sections.findIndex((section) => section.dataset.category === categoryGesture.category);
      const atEdge = (index === 0 && dx > 0) || (index === sections.length - 1 && dx < 0);
      const width = $('.ac-category-stage').clientWidth;
      positionCategorySlider(categoryGesture.offset + Math.max(-width, Math.min(width, atEdge ? dx * 0.2 : dx)));
    }
  }, {passive: false});
  function finishCategoryGesture(event) {
    const gesture = categoryGesture;
    if (!gesture || event.pointerId !== gesture.pointerId) return;
    categoryGesture = null;
    $('.ac-catalog').classList.remove('is-dragging');
    const cancelled = event.type === 'pointercancel' || event.type === 'lostpointercapture';
    const dx = cancelled ? gesture.dx : (event.clientX - gesture.x || gesture.dx);
    const horizontal = gesture.horizontal || (!cancelled && Math.abs(dx) >= 2 && Math.abs(dx) > Math.abs(event.clientY - gesture.y));
    if (horizontal) suppressSwipeClickUntil = performance.now() + 500;
    // Once horizontal intent is established, even a small, slow swipe completes
    // the turn. Rechecking distance or angle here made valid drags spring back.
    if (!mobileCategories.matches || query || !horizontal || dx === 0) { positionCategorySlider(); return; }
    const sections = $$('.ac-category-section');
    const index = sections.findIndex((section) => section.dataset.category === gesture.category);
    const next = sections[index + (dx < 0 ? 1 : -1)];
    if (next) {
      scrollToCategory(next.dataset.category, true);
      $('#category-swipe-status').textContent = next.querySelector('h2').textContent;
    } else positionCategorySlider();
  }
  window.addEventListener('pointerup', finishCategoryGesture);
  // Safari can hand a slow gesture to native panning after horizontal intent
  // was already detected. Complete that turn instead of snapping the track back.
  window.addEventListener('pointercancel', finishCategoryGesture);
  window.addEventListener('lostpointercapture', finishCategoryGesture);
  function finishTouchGesture(event) {
    if (!event.touches.length && categoryGesture?.horizontal) {
      finishCategoryGesture({type: 'pointercancel', pointerId: categoryGesture.pointerId});
    }
  }
  window.addEventListener('touchend', finishTouchGesture, {passive: true});
  window.addEventListener('touchcancel', finishTouchGesture, {passive: true});
  const pinchDistance = (touches) => Math.hypot(touches[0].clientX - touches[1].clientX, touches[0].clientY - touches[1].clientY);
  root.addEventListener('touchstart', (event) => {
    if (!mobileCategories.matches || event.touches.length !== 2) { productPinch = null; return; }
    const dialog = $('#item-dialog');
    const target = event.touches[0].target;
    const tile = target.closest?.('[data-product]');
    const inDetail = dialog.open && target.closest?.('#item-dialog');
    if (!tile && !inDetail) return;
    cancelCategoryGesture();
    const distance = pinchDistance(event.touches);
    if (distance < 8) return;
    productPinch = {distance, id: tile?.dataset.product, closing: Boolean(inDetail), done: false};
    if (event.cancelable) event.preventDefault();
  }, {passive: false});
  root.addEventListener('touchmove', (event) => {
    if (!productPinch || event.touches.length !== 2) return;
    if (event.cancelable) event.preventDefault();
    if (productPinch.done) return;
    const ratio = pinchDistance(event.touches) / productPinch.distance;
    if (productPinch.closing ? ratio <= 0.88 : ratio >= 1.12) {
      productPinch.done = true;
      suppressSwipeClickUntil = performance.now() + 800;
      if (productPinch.closing) closeZoomedItem(); else showItem(productPinch.id);
    }
  }, {passive: false});
  const endProductPinch = (event) => {
    if (event.touches.length < 2) {
      if (productPinch?.done) suppressSwipeClickUntil = performance.now() + 500;
      productPinch = null;
    }
  };
  window.addEventListener('touchend', endProductPinch, {passive: true});
  window.addEventListener('touchcancel', endProductPinch, {passive: true});
  window.addEventListener('blur', cancelCategoryGesture);
  mobileCategories.addEventListener('change', () => { cancelCategoryGesture(); observeCategories(); });
  root.addEventListener('keydown', () => { suppressSwipeClickUntil = 0; });
  root.addEventListener('click', (event) => {
    if (performance.now() < suppressSwipeClickUntil) {
      suppressSwipeClickUntil = 0;
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  root.addEventListener('click', (event) => {
    const languageButton = event.target.closest('[data-lang]');
    if (languageButton) {
      lang = languageButton.dataset.lang;
      try { localStorage.setItem('aussie-menu-language', lang); } catch (_) { /* Storage is optional. */ }
      localize();
      updateHeaderHeight();
      document.title = `${location.hash === '#rolezinho' ? (lang === 'en' ? 'My Rio rolezinho' : 'Meu rolezinho no Rio') : location.hash === '#comunidade' ? t('communityTitle') : (lang === 'en' ? 'Menu' : 'Cardápio')} · Aussie Coffee`;
      return;
    }
    const roleJump = event.target.closest('[data-role-jump]');
    if (roleJump) { event.preventDefault(); document.getElementById(roleJump.dataset.roleJump).scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}); return; }
    const communityButton = event.target.closest('[data-community-profile]');
    if (communityButton) { document.getElementById(communityButton.dataset.communityProfile).showModal(); return; }
    const productButton = event.target.closest('[data-product]');
    if (productButton) { showItem(productButton.dataset.product); return; }
    const categoryLink = event.target.closest('a[data-category]');
    if (categoryLink) {
      event.preventDefault();
      if ($('#category-dialog').open) $('#category-dialog').close();
      scrollToCategory(categoryLink.dataset.category);
      return;
    }
    const closeButton = event.target.closest('[data-close-dialog]');
    if (closeButton) closeButton.closest('dialog').close();

  });
  $('#menu-search').addEventListener('input', (event) => { query = event.target.value.trim(); renderCatalog(); window.scrollTo({top: 0, behavior: 'instant'}); });
  $('#clear-search').addEventListener('click', () => { resetSearch(); $('#menu-search').focus(); });
  $('#reset-search').addEventListener('click', () => { resetSearch(); $('#menu-search').focus(); });
  $('#open-categories').addEventListener('click', () => $('#category-dialog').showModal());
  $$('dialog').forEach((dialog) => dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  }));
  $('#item-dialog').addEventListener('close', () => {
    currentItem = null;
    productPinch = null;
    clearTimeout(detailCloseTimer);
    $('#item-dialog').classList.remove('is-zoom-closing');
    if (mobileCategories.matches) window.scrollTo({top: detailScrollY, behavior: 'instant'});
  });
  document.querySelector('.ac-skip-link')?.addEventListener('click', (event) => {
    event.preventDefault();
    const main = document.getElementById('MainContent');
    main.focus({preventScroll: true});
    main.scrollIntoView({behavior: 'instant'});
  });
  root.addEventListener('error', (event) => { if (event.target.tagName === 'IMG') event.target.style.visibility = 'hidden'; }, true);
  window.addEventListener('hashchange', applyRoute);
  window.addEventListener('resize', updateCommunityArtwork);
  root.addEventListener('toggle', (event) => {
    if (event.target.matches('.ac-network-category')) requestAnimationFrame(updateCommunityArtwork);
  }, true);
  window.addEventListener('scroll', () => {
    if (!communityArtworkFrame && !$('#community-view').hidden) communityArtworkFrame = requestAnimationFrame(updateCommunityArtwork);
  }, {passive: true});
  new ResizeObserver(updateHeaderHeight).observe($('.ac-menu-header'));
  const communitySearch = $('#community-search');
  const communityClear = $('#community-search-clear');
  let communityTypingTimer;
  let communityWord = 0;
  let communityLetters = 0;
  let communityDeleting = false;
  const normalizeCommunity = (value) => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  function filterCommunity() {
    const query = normalizeCommunity(communitySearch.value.trim());
    let matches = 0;
    $$('.ac-network-category').forEach((category) => {
      let count = 0;
      category.querySelectorAll('[data-community-search]').forEach((person) => {
        person.hidden = Boolean(query) && !normalizeCommunity(person.dataset.communitySearch).includes(query);
        if (!person.hidden) count++;
      });
      category.hidden = Boolean(query) && count === 0;
      if (query && count) category.open = true;
      matches += count;
    });
    communityClear.hidden = !query;
    $('#community-search-status').textContent = query ? (matches ? `${matches} ${t('communityMatches')}` : t('communityNoResults')) : '';
    requestAnimationFrame(updateCommunityArtwork);
  }
  function refreshCommunitySearch() {
    clearTimeout(communityTypingTimer);
    communityWord = 0;
    communityLetters = 0;
    communityDeleting = false;
    communitySearch.placeholder = t('communitySearchPrompt');
    filterCommunity();
    if (document.activeElement !== communitySearch && !communitySearch.value && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) communityTypingTimer = setTimeout(typeCommunityExample, 900);
  }
  function typeCommunityExample() {
    if (document.activeElement === communitySearch || communitySearch.value) return;
    if ($('#community-view').hidden || document.hidden) {
      communityTypingTimer = setTimeout(typeCommunityExample, 1000);
      return;
    }
    const words = lang === 'en' ? ['Lawyer', 'Real estate', 'Yoga', 'Accounting', 'Tours', 'Art'] : ['Advogado', 'Imóveis', 'Yoga', 'Contabilidade', 'Passeios', 'Arte'];
    const word = words[communityWord % words.length];
    communityLetters += communityDeleting ? -1 : 1;
    communitySearch.placeholder = word.slice(0, communityLetters);
    let delay = communityDeleting ? 55 : 120;
    if (communityLetters === word.length) { communityDeleting = true; delay = 1500; }
    else if (communityLetters === 0) { communityDeleting = false; communityWord++; delay = 350; }
    communityTypingTimer = setTimeout(typeCommunityExample, delay);
  }
  communitySearch.addEventListener('focus', () => { clearTimeout(communityTypingTimer); communitySearch.placeholder = t('communitySearchPrompt'); });
  communitySearch.addEventListener('blur', refreshCommunitySearch);
  communitySearch.addEventListener('input', filterCommunity);
  communityClear.addEventListener('click', () => { communitySearch.value = ''; filterCommunity(); communitySearch.focus(); });
  const caipibara = $('[data-caipibara]');
  const caipibaraTap = $('[data-caipibara-tap]');
  const caipibaraDancer = caipibara.querySelector('.ac-caipibara-dancer');
  const caipibaraMusic = $('[data-caipibara-music]');
  const caipibaraPlayer = $('[data-caipibara-player]');
  const caipibaraBubble = $('[data-caipibara-bubble]');
  const caipibaraReviewUrl = 'https://g.page/r/CVAEvTrnFlzDEBM/review';
  let caipibaraTaps = 0;
  let caipibaraGrowthTaps = 0;
  caipibara.classList.add('is-settled');
  for (let look = 1; look <= 5; look++) {
    const preload = new Image();
    preload.src = caipibaraDancer.getAttribute(`data-look-${look}`);
  }
  ['data-wink', 'data-heart', 'data-signs', 'data-snap'].forEach((attribute) => {
    const preload = new Image();
    preload.src = caipibaraDancer.getAttribute(attribute);
  });
  let caipibaraVideo;
  let caipibaraPreviewTimer;
  let caipibaraPreviewStarted = false;
  const caipibaraKeepWatching = $('[data-caipibara-keep-watching]');
  function startCaipibaraPreview() {
    if (caipibaraPreviewStarted || caipibaraTaps !== 5) return;
    caipibaraPreviewStarted = true;
    const deadline = performance.now() + 5000;
    caipibaraKeepWatching.hidden = false;
    const update = () => {
      const seconds = Math.max(0, Math.ceil((deadline - performance.now()) / 1000));
      $('[data-caipibara-countdown]').textContent = lang === 'en'
        ? `Click video to keep watching · ${seconds}s`
        : `Toque no vídeo para continuar · ${seconds}s`;
      if (!seconds) { clearInterval(caipibaraPreviewTimer); caipibaraTap.click(); }
    };
    update();
    caipibaraPreviewTimer = setInterval(update, 100);
  }
  caipibaraKeepWatching.addEventListener('click', () => {
    clearInterval(caipibaraPreviewTimer);
    caipibaraKeepWatching.hidden = true;
  });
  let caipibaraVideoReady = false;
  let caipibaraPlayerPreparing = false;
  let caipibaraYouTubeReady;
  function loadCaipibaraYouTube() {
    if (window.YT?.Player) return Promise.resolve(window.YT);
    if (caipibaraYouTubeReady) return caipibaraYouTubeReady;
    caipibaraYouTubeReady = new Promise((resolve, reject) => {
      const previousReady = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        if (previousReady) previousReady();
        resolve(window.YT);
      };
      if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.onerror = reject;
        document.head.append(script);
      }
    });
    return caipibaraYouTubeReady;
  }
  function setCaipibaraPlayback(playing) {
    if (caipibaraTaps !== 5) return;
    caipibara.classList.toggle('is-music-playing', playing);
    const pose = caipibaraDancer.getAttribute('data-look-5');
    caipibaraDancer.style.backgroundImage = `url("${pose}")`;
    caipibaraDancer.style.setProperty('--ac-caipibara-static', caipibaraDancer.style.backgroundImage);
    $('[data-caipibara-question]').hidden = true;
    $('[data-caipibara-review]').hidden = true;
    $('[data-caipibara-stop]').hidden = true;
    $('[data-caipibara-stop]').textContent = lang === 'en' ? 'Click to stop' : 'Toque para parar';
    caipibaraBubble.hidden = true;
  }
  function prepareCaipibaraPlayer() {
    if (caipibaraPlayerPreparing || caipibaraVideo || caipibaraTaps >= 6 || caipibara.hidden) return;
    caipibaraPlayerPreparing = true;
    const player = document.createElement('iframe');
    player.src = `https://www.youtube-nocookie.com/embed/8Pj-YEQbojk?autoplay=0&playsinline=1&rel=0&controls=0&fs=0&enablejsapi=1&origin=${encodeURIComponent(location.origin)}`;
    player.title = 'The Capybara Song';
    player.width = '200';
    player.height = '356';
    player.allow = 'autoplay; encrypted-media; picture-in-picture';
    player.referrerPolicy = 'strict-origin-when-cross-origin';
    player.allowFullscreen = true;
    caipibaraPlayer.replaceChildren(player);
    loadCaipibaraYouTube().then((YT) => {
      if (!player.isConnected || caipibaraTaps >= 6 || caipibara.hidden) return;
      caipibaraVideo = new YT.Player(player, { events: {
        onReady: (event) => {
          caipibaraVideoReady = true;
          caipibara.dataset.playerReady = 'true';
          if (caipibaraTaps === 5 && !caipibara.hidden) { event.target.unMute(); event.target.playVideo(); }
        },
        onStateChange: (event) => {
          if (event.data === 1) { setCaipibaraPlayback(true); startCaipibaraPreview(); }
          else if (event.data === 0 && caipibaraTaps === 5) caipibaraTap.click();
          else if (event.data === 2) setCaipibaraPlayback(false);
        },
        onAutoplayBlocked: () => setCaipibaraPlayback(false)
      } });
    }).catch(() => { caipibaraPlayerPreparing = false; });
  }
  function stopCaipibaraMusic() {
    clearInterval(caipibaraPreviewTimer);
    caipibaraKeepWatching.hidden = true;
    if (caipibaraVideo) { caipibaraVideo.destroy(); caipibaraVideo = null; }
    caipibaraVideoReady = false;
    caipibaraPlayerPreparing = false;
    delete caipibara.dataset.playerReady;
    caipibaraPlayer.replaceChildren();
    caipibaraMusic.hidden = true;
    caipibara.classList.remove('is-music-playing');
  }
  caipibaraTap.addEventListener('click', (event) => {
    if (event.isTrusted) {
      caipibaraGrowthTaps++;
      caipibara.style.setProperty('--ac-caipibara-scale', String(1 + caipibaraGrowthTaps * 0.1));
    }
    if (caipibaraTaps >= 6) {
      openCaipibaraReview();
      return;
    }
    caipibaraTaps++;
    if (caipibaraTaps === 1) prepareCaipibaraPlayer();
    caipibara.dataset.reaction = String(Math.min(caipibaraTaps, 5));
    if (caipibaraTaps <= 5) {
      caipibaraDancer.style.backgroundImage = `url("${caipibaraDancer.getAttribute(`data-look-${caipibaraTaps}`)}")`;
      caipibaraDancer.style.setProperty('--ac-caipibara-static', caipibaraDancer.style.backgroundImage);
      caipibara.querySelectorAll('.ac-caipibara-stars span').forEach((star, index) => star.classList.toggle('is-earned', index < caipibaraTaps));
      $('[data-caipibara-status]').textContent = `${caipibaraTaps} / 5 ${lang === 'en' ? 'stars' : 'estrelas'}`;
    }
    if (caipibaraTaps === 5) {
      caipibaraMusic.hidden = false;
      // Keep playback in the fifth tap's synchronous handler once preloaded.
      if (caipibaraVideoReady && caipibaraVideo) {
        caipibaraVideo.unMute();
        caipibaraVideo.playVideo();
      } else {
        prepareCaipibaraPlayer();
      }
      caipibaraTap.setAttribute('aria-label', lang === 'en' ? 'Stop music' : 'Parar música');
    } else if (caipibaraTaps === 6) {
      stopCaipibaraMusic();
      caipibaraDancer.style.backgroundImage = `url("${caipibaraDancer.getAttribute('data-signs')}")`;
      caipibaraDancer.style.setProperty('--ac-caipibara-static', caipibaraDancer.style.backgroundImage);
      $('[data-caipibara-question]').hidden = false;
       $('[data-caipibara-review]').hidden = true;
      $('[data-caipibara-choices]').hidden = true;
      $('[data-caipibara-stop]').hidden = true;
      speakCaipibara(caipibaraMessage());
      $('[data-caipibara-review]').textContent = lang === 'en' ? 'Review us on Google ↗' : 'Avaliar no Google ↗';
      caipibaraBubble.hidden = false;
      caipibaraTap.setAttribute('aria-label', lang === 'en' ? 'Leave feedback for Aussie Coffee' : 'Avaliar a Aussie Coffee');
    }
  });
  function caipibaraMessage() {
    return lang === 'en' ? "Heya! We're hidden back here right... reviews really help us to find ya'll! Were wondering, would ya'll mind leaving a review or some feedback?" : 'Oiee! A gente fica bem escondidinho aqui, né... As avaliações ajudam a galera a encontrar a gente, de verdade! Cês topam deixar uma avaliação ou um feedback rapidinho?';
  }
  let caipibaraSpeechLanguage;
  function localizeCaipibara() {
    $('[data-caipibara-status]').textContent = caipibaraTaps ? `${Math.min(caipibaraTaps, 5)} / 5 ${lang === 'en' ? 'stars' : 'estrelas'}` : '';
    if (caipibaraTaps >= 6 && !caipibara.hidden && !caipibara.classList.contains('is-snapping-away') && caipibaraSpeechLanguage !== lang) {
      const wasSpeaking = caipibaraBubble.classList.contains('is-speaking');
      speakCaipibara(caipibaraMessage());
      if (!wasSpeaking && finishCaipibaraSpeech) finishCaipibaraSpeech();
      caipibaraTap.setAttribute('aria-label', lang === 'en' ? 'Leave feedback for Aussie Coffee' : 'Avaliar a Aussie Coffee');
    } else if (caipibaraTaps === 5) {
      caipibaraTap.setAttribute('aria-label', lang === 'en' ? 'Stop music' : 'Parar música');
    }
    reviewSheet.querySelectorAll('[data-review-copy]').forEach(el => { el.textContent = reviewWords[lang][el.dataset.reviewCopy]; });
  }
  let caipibaraSpeechTimer;
  let finishCaipibaraSpeech;
  function speakCaipibara(message) {
    caipibaraSpeechLanguage = lang;
    clearTimeout(caipibaraSpeechTimer);
    const question = $('[data-caipibara-question]');
    const accessible = document.createElement('span');
    accessible.className = 'ac-sr-only';
    accessible.textContent = message;
    const visual = document.createElement('span');
    visual.setAttribute('aria-hidden', 'true');
    const words = message.match(/\S+\s*/g) || [];
    const pieces = words.map(word => {
      const span = document.createElement('span');
      span.textContent = word;
      span.style.visibility = 'hidden';
      visual.append(span);
      return span;
    });
    question.replaceChildren(accessible, visual);
    caipibaraBubble.classList.add('is-speaking');
    finishCaipibaraSpeech = () => {
      clearTimeout(caipibaraSpeechTimer);
      pieces.forEach(span => { span.style.visibility = 'visible'; });
      caipibaraBubble.classList.remove('is-speaking');
      $('[data-caipibara-choices]').hidden = false;
      finishCaipibaraSpeech = null;
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { finishCaipibaraSpeech(); return; }
    let index = 0;
    const reveal = () => {
      if (caipibara.hidden) { clearTimeout(caipibaraSpeechTimer); return; }
      pieces[index].style.visibility = 'visible';
      const word = words[index++].trim();
      if (index === pieces.length) { finishCaipibaraSpeech(); return; }
      caipibaraSpeechTimer = setTimeout(reveal, /[!?.,]$/.test(word) ? 420 : 150 + Math.min(word.length * 12, 100));
    };
    reveal();
  }
  caipibaraBubble.addEventListener('click', () => { if (finishCaipibaraSpeech) finishCaipibaraSpeech(); });
  const reviewSheet = $('#caipibara-review-sheet');
  const reviewWords = {
    en: { title: 'How was your visit?', intro: 'We’d love to hear from you.', improve: 'Help us improve', improveNote: 'Share constructive feedback with our team', comment: 'What could we do better?', google: 'Help us be seen ↗', googleNote: 'Leave a review on Google', email: 'Your email', phone: 'Phone number (optional)', send: 'Send privately' },
    pt: { title: 'Como foi sua visita?', intro: 'A gente quer ouvir você.', improve: 'Ajude a gente a melhorar', improveNote: 'Compartilhe sugestões com a nossa equipe', comment: 'O que a gente pode melhorar?', google: 'Ajude a gente a aparecer ↗', googleNote: 'Deixe uma avaliação no Google', email: 'Seu e-mail', phone: 'Telefone (opcional)', send: 'Enviar em particular' }
  };
  function openCaipibaraReview() {
    if (finishCaipibaraSpeech) finishCaipibaraSpeech();
    reviewSheet.querySelectorAll('[data-review-copy]').forEach(el => { el.textContent = reviewWords[lang][el.dataset.reviewCopy]; });
    reviewSheet.showModal();
  }
  $('[data-caipibara-yep]').addEventListener('click', openCaipibaraReview);
  $('[data-caipibara-next]').addEventListener('click', () => {
    stopCaipibaraMusic();
    $('[data-caipibara-choices]').hidden = true;
    caipibaraBubble.hidden = true;
    caipibaraTap.disabled = true;
    caipibaraDancer.style.backgroundImage = `url("${caipibaraDancer.getAttribute('data-snap')}")`;
    caipibaraDancer.style.setProperty('--ac-caipibara-static', caipibaraDancer.style.backgroundImage);
    caipibara.classList.add('is-snapping-away');
    $('[data-caipibara-status]').textContent = lang === 'en' ? 'See you next time!' : 'Até a próxima!';
    setTimeout(() => { caipibara.hidden = true; }, 1100);
  });
  $('[data-review-improve]').addEventListener('click', () => {
    const panel = $('#ac-review-private-panel');
    panel.hidden = !panel.hidden;
    $('[data-review-improve]').setAttribute('aria-expanded', String(!panel.hidden));
  });
  if (new URLSearchParams(location.search).get('feedback') === 'sent') {
    openCaipibaraReview();
    $('[data-review-feedback]').textContent = lang === 'en' ? 'Thanks for sharing your feedback with our team.' : 'Obrigado por compartilhar sua opinião com a nossa equipe.';
  }
  $('[data-caipibara-video-close]').addEventListener('click', () => { if (caipibaraTaps === 5) caipibaraTap.click(); else stopCaipibaraMusic(); });
  $('[data-caipibara-stop]').addEventListener('click', () => caipibaraTap.click());
  caipibara.querySelector('.ac-caipibara-dismiss').addEventListener('click', () => {
    stopCaipibaraMusic();
    clearTimeout(caipibaraSpeechTimer);
    caipibara.hidden = true;
  });
  localize();
  applyRoute();
})();
